import { render, staticRenderFns } from "./LoPrimo.vue?vue&type=template&id=914aa240&scoped=true&"
import script from "./LoPrimo.vue?vue&type=script&lang=js&"
export * from "./LoPrimo.vue?vue&type=script&lang=js&"
import style0 from "./LoPrimo.vue?vue&type=style&index=0&id=914aa240&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914aa240",
  null
  
)

export default component.exports